import {
  LayoutDashboard,
  Users,
  ShoppingCart,
  CreditCard,
  Clock,
  Wallet,
  Gift,
  BarChart3,
  Percent,
  Image,
  Bell,
  MessageCircle,
} from 'lucide-react';

// Product catalogue management intentionally does not live in this admin app.
// Products, categories, subcategories, brands and website/app pricing are
// created and edited only in the KeyShop Inventory & POS application.
const menuConfig = [
  { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
  { id: 'orders', label: 'Orders', icon: ShoppingCart, path: '/orders' },
  { id: 'users', label: 'Users', icon: Users, path: '/users' },
  { id: 'bill-to-bill', label: 'Bill to Bill', icon: CreditCard, path: '/bill-to-bill' },
  { id: 'tenure', label: 'Tenure', icon: Clock, path: '/tenure' },
  { id: 'wallet-topup', label: 'Wallet Topup', icon: Wallet, path: '/wallet-topup' },
  { id: 'points-rules', label: 'Points Rules', icon: Gift, path: '/points-rules' },
  { id: 'points-analytics', label: 'Points Analytics', icon: BarChart3, path: '/points-analytics' },
  { id: 'discounts', label: 'Category Discounts', icon: Percent, path: '/discounts' },
  { id: 'banners', label: 'Banners', icon: Image, path: '/banners' },
  { id: 'notifications', label: 'Notifications', icon: Bell, path: '/notifications' },
  { id: 'support', label: 'Support', icon: MessageCircle, path: '/support' },
];

export const validateMenuConfig = (config) => {
  const errors = [];
  config.forEach((item, index) => {
    if (!item.id) errors.push(`Menu item at index ${index} is missing id`);
    if (!item.label) errors.push(`Menu item at index ${index} is missing label`);
    if (!item.icon) errors.push(`Menu item at index ${index} is missing icon`);
    if (!item.path) errors.push(`Menu item at index ${index} is missing path`);
  });
  return { valid: errors.length === 0, errors };
};

export const getMenuConfig = () => menuConfig;

export default menuConfig;
